import { AutogenLayoutCommodityList } from "./autogen/AutogenLayoutCommodityList";
import { LMECompanySettings } from "@mcleod/general";

export class CommodityList extends AutogenLayoutCommodityList {
    override onLoad() {
        this.showLTLColumns();
    }

    showLTLColumns() {
        if (LMECompanySettings.getSingleton().isBrokerageLtl() !== true) {
            this.tableCommodity.removeColumn("nmfcClassCode");
            this.tableCommodity.removeColumn("nmfcCode");
        }
    }
}
